import HologardeBackground from '@assets/hologarde-background.jpg';
import { Button, Card, Flex, Heading, Image, Spinner, Stack } from '@chakra-ui/react';
import LogoutButton from '@components/login/LogoutButton';
import { useUpdateDisplayModeMutation } from '@services/authent/user.api';
import { FormattedMessage } from 'react-intl';

import { DisplayModeEnum } from '@/types/authent/login.types';

export default function DisplayModeConfiguration() {
  const [updateDisplayMode, { isLoading }] = useUpdateDisplayModeMutation();
  const handleClick = (display: DisplayModeEnum) => () => {
    updateDisplayMode({ displayMode: display });
  };

  return (
    <Flex width="100%" height="100%" fontFamily="roboto" alignItems="center">
      <Image src={HologardeBackground} fit="cover" height="100%" width="100%" position="absolute" />
      <Flex position="absolute" top={2} right={2} gap={1}>
        <LogoutButton />
      </Flex>
      <Card.Root borderRadius={0} marginLeft="auto" marginRight="50px">
        <Card.Header padding="20px">
          <Heading size="xl">
            <FormattedMessage id="displayModeChoice.title" />
          </Heading>
        </Card.Header>
        <Card.Body
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="500px"
          padding="20px"
        >
          <FormattedMessage id="displayModeChoice.selectDisplayMode" />
          {isLoading ? (
            <Spinner size="xl" margin={5} />
          ) : (
            <Stack width="80%">
              <Button border="1px solid" height="150px" onClick={handleClick(DisplayModeEnum.MULTI_TABS_WITH_COCKPIT)}>
                <FormattedMessage id="displayModeChoice.multiScreensMode" />
              </Button>
              <Button border="1px solid" height="150px" onClick={handleClick(DisplayModeEnum.TWO_TABS)}>
                <FormattedMessage id="displayModeChoice.twoScreensMode" />
              </Button>
              <Button border="1px solid" height="150px" onClick={handleClick(DisplayModeEnum.MONO_TAB)}>
                <FormattedMessage id="displayModeChoice.monoScreenMode" />
              </Button>
            </Stack>
          )}
        </Card.Body>
      </Card.Root>
    </Flex>
  );
}
